import { useEffect, useRef } from 'react';
import { getQueryStringValue } from '../types';
/**
 * Readonly hook to get a value from the query string
 *
 * @param key The key to get the value for
 * @param initialValue The initial value to use if the key is not present in the query string. Defaults to an empty string.
 * @returns The value from the query string
 */
export function useQueryString({ key, initialValue = '', }) {
    const queryStringValue = getQueryStringValue(key);
    const value = useRef(queryStringValue ?? initialValue);
    useEffect(() => {
        if (value.current !== queryStringValue) {
            value.current = queryStringValue ?? initialValue;
        }
    }, [queryStringValue, value, initialValue]);
    return value.current;
}
